import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { saRrcEstablishmentChartConfig } from '../chartConfigs';

interface RrcEstablishmentSaEchartsProps {
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const RrcEstablishmentSaEcharts: React.FC<RrcEstablishmentSaEchartsProps> = ({ onFullscreenToggle, isFullscreen }) => (
  <SiteCharts config={saRrcEstablishmentChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} />
);

export default RrcEstablishmentSaEcharts;
